import type { GuideTourStep } from '../types'
import * as S from './styles'

type GuideTourStepCardBodyProps = Readonly<{
  currentStep: GuideTourStep
  isSummaryOnly: boolean
  stepImageUrl: string | null
}>

export function GuideTourStepCardBody({
  currentStep,
  isSummaryOnly,
  stepImageUrl,
}: GuideTourStepCardBodyProps) {
  return (
    <>
      {stepImageUrl ? (
        <S.ImageArea>
          <S.Image
            data-testid="guide-tour-step-image"
            src={stepImageUrl}
            alt=""
          />
        </S.ImageArea>
      ) : null}

      <S.Content>
        {isSummaryOnly ? null : (
          <S.Title id="guide-tour-step-title">{currentStep.title}</S.Title>
        )}
        {isSummaryOnly ? null : (
          <S.Body id="guide-tour-step-body">{currentStep.body}</S.Body>
        )}
      </S.Content>
    </>
  )
}
